module.exports = __webpack_public_path__ + "static/media/medium_photo.43f438d1.jpg";